
export class SellerDTO {
  constructor(
  public name: string,
  public bankNumber: string,
  public address: string,
  public postalCode: string,
  public city: string,
  public country: string,
  public taxNumber: string | null,
  ) {}
}
